/* eslint-disable */
const prefix = '/api/surveys';

export default {
    state: {
        surveysList: [],
        surveyId: null,
        currentSurvey: null,
        currentSurveyAnswers: null,
        currentSurveyComplete: null,
        surveyPassings: [],
    },
    mutations: {
        setSurveysList(state, payload) {
            state.surveysList = payload;
        },
        setSurveysPassings(state, payload) {
            state.surveyPassings = payload;
        },
        setCurrentSurvey(state, payload) {
            state.currentSurvey = payload;
        },
        setCurrentSurveyAnswers(state, payload) {
            state.currentSurveyAnswers = payload;
        },
        setSurveyCompleteResponse(state, payload) {
            state.currentSurveyComplete = payload;
        },
        setSurveyId(state, payload) {
            state.surveyId = payload;
        },
    },
    actions: {
        setSId(context, payload) {
            this.commit('setSurveyId', payload.id);
        },
        getListOfSurveys() {
            const url = `${prefix}`;
            return this._vm.$apiClient.get(url).then((response) => {
                console.log(response);
                /* console.log(response.status_code); */
                if (response.hasOwnProperty('status')){
                    console.log("response has status");
                    if (response.status === 200) {
                        console.log("response has status === 200");
                        this.commit('setSurveysList', response.data);
                    }
                }
                else if (response.hasOwnProperty('status_code')) {
                    if (response.status_code === 200) {
                        this.$store.dispatch('logout').finally(() => {
                            this.$router.push('/sign-in')
                        })
                    }
                }
                return response;
            });
        },
        getSurveyPassings() {
            const url = `${prefix}-passings/all`;
            return this._vm.$apiClient.get(url).then((response) => {
                this.commit('setSurveysPassings', response.data);
                return response;
            });
        },
        getCurrentSurvey(context, payload) {
            const url = `${prefix}/${payload.id}`;
            return this._vm.$apiClient.get(url, {include:'questions'})
                .then((response) => {
                    this.commit('setCurrentSurvey', response.data);
                    return response.data;
                });
        },
        getCurrentSurveyAnswers(context, payload) {
            const url = `${prefix}-passings/current`;
            return this._vm.$apiClient.get(url, {include:'answers', survey_id: payload.id})
                .then((response) => {
                    this.commit('setCurrentSurveyAnswers', response.data);
                    return response.data;
                });
        },
        saveFeedback(context, payload) {
            const url = `/api/answers/create`;
            return new Promise((resolve, reject) => {
                this._vm.$apiClient.post(url, payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    });
            });
        },
        setSurveyComplete(context, payload) {
            const url = `${prefix}-passings/complete`;
            return this._vm.$apiClient.get(url, {include:'answers', survey_id: payload.id})
                .then((response) => {
                    this.commit('setSurveyCompleteResponse', response.data);
                    return response.data;
                });
        }
    },
    getters: {
    },
}
